import React from "react";

export const KiemKhoCombo = {
  KhoDefault: "- Kho -",
  KhoCombo: [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Kho 1" },
    { value: "2", label: "Kho 2" },
  ],
  TrangThaiKiemDefault: "- Trạng thái -",
  TrangThaiKiemCombo: [
    { value: "-1", label: "Tất cả" },
    { value: "0", label: "Chưa kiểm" },
    { value: "1", label: "Đã kiểm" },
  ],
};
